import React from 'react'
import classNames from 'classnames'
import { confirmBase } from 'utils/ui'
import { modalTodoEditor } from 'pages/todo/components/TodoEditor'
import { TodoItem } from '../../modules/TodoItem'
import TodoDetails from './index'
import styles from './style.module.scss'

export function modalTodoDetails(
  todo: TodoItem,
  onTodoUpdate: ((todo: TodoItem) => void) | null = null,
) {
  const modalObj = confirmBase({
    wrapClassName: styles.todoDetailsPopup,
    className: classNames('mobile-fullpage'),
    width: 480,
    closable: false,
    content: (
      <TodoDetails
        todo={todo}
        onEdit={(editTodo) => {
          console.log('Edit todo:', editTodo)
          modalObj.destroy()
          modalTodoEditor(editTodo)
        }}
        onDuplicate={(dupTodo) => {
          console.log('Duplicate todo:', dupTodo)
          modalObj.destroy()
          modalTodoEditor(dupTodo, true)
        }}
        onTodoDelete={(delTodo) => {
          console.log('Delete todo:', delTodo)
          modalObj.destroy()
        }}
        onTodoUpdate={onTodoUpdate}
        onCancel={() => modalObj.destroy()}
        onClose={() => modalObj.destroy()}
      />
    ),
    footer: null,
  })

  return modalObj
}
